import { useTranslation } from 'next-i18next';
import * as React from 'react';

import 'react-datepicker/dist/react-datepicker.min.css';
import styles from './SingleQrCode.module.css';

import { NextImage, Typography } from '@/shared/components/atoms';
import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';
import { clsxm } from '@/shared/lib';

import PoweredByLogo from '~/images/shared/poweredByLogo.svg';

interface IQrCodeProps {
  variant?: 'single' | 'multiple';
  className?: string;
  qrData: {
    qrCode: string | undefined;
    logo?: string;
    name?: string;
    title?: string;
  };
}

const SingleQrCode = React.forwardRef<HTMLDivElement, IQrCodeProps>(
  ({ qrData, variant = 'single', className }, ref) => {
    const {
      i18n: { dir },
    } = useTranslation('common');

    const outerWrapperClasses = clsxm(
      styles[`outerWrapper-${variant}`],
      className
    );
    const dividerClasses = clsxm(styles[`divider-${variant}`]);
    const contentClasses = clsxm(styles[`content-${variant}`]);
    const logoClasses = clsxm(styles[`logo-${variant}`]);
    const qrCodeClasses = clsxm('w-full', styles[`qrCode-${variant}`]);

    return (
      <div className={outerWrapperClasses}>
        {/* *****************  divider ******************* */}
        <div className={dividerClasses} />

        {/* ***************** content ******************** */}

        <div ref={ref} className={contentClasses}>
          {/* ***** company logo ****** */}
          <NextImage
            priority
            fill
            useSkeleton
            src={qrData?.logo || ''}
            alt='company logo'
            className={logoClasses}
          />
          <div className='h-42'>
            {/* ******** Name ******** */}
            <Typography
              dir={dir()}
              variant={variant === 'single' ? 'h3' : 'subtitle2'}
              weight='bold'
              className='w-full text-black'
            >
              {qrData?.name}
            </Typography>
            {/* ******** Title ******* */}
            <Typography
              variant={variant === 'single' ? 'subtitle1' : 'subtitle2'}
              className='text-text-secondary'
            >
              {qrData?.title}
            </Typography>
          </div>
          {/* ******** QR code ******** */}
          <NextImage
            priority
            fill
            useSkeleton
            src={qrData?.qrCode || ''}
            alt='qr code'
            className={qrCodeClasses}
          />
          {/* TODO : ADD farm / line number / crop name */}

          {/* ******** powered by ******* */}
          <div className='flex items-center whitespace-nowrap print:flex-row-reverse'>
            <BaseIcon svgClasses='w-48'>
              <PoweredByLogo />
            </BaseIcon>

            <Typography variant='subtitle1' className='mx-1 text-text-600'>
              Powered by
            </Typography>
          </div>
        </div>
      </div>
    );
  }
);
export default SingleQrCode;
